<glxy-form-field>
  <glxy-label>{{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.OPPORTUNITY_NAME' | translate }}</glxy-label>
  <input
    matInput
    [formControl]="opportunityNameControl"
    placeholder="{{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.OPPORTUNITY_NAME' | translate }}"
  />
</glxy-form-field>
